import { render } from "./transactionManagement.vue?vue&type=template&id=4884993f&scoped=true"
import script from "./transactionManagement.vue?vue&type=script&lang=js"
export * from "./transactionManagement.vue?vue&type=script&lang=js"

import "./transactionManagement.vue?vue&type=style&index=0&id=4884993f&lang=css"
import "./transactionManagement.vue?vue&type=style&index=1&id=4884993f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4884993f"]])

export default __exports__